export type PageRule = {
    rule: string;
    page: string;
};

export const NPAW_PAGE_RULES: PageRule[] = [
    { rule: '.*/play/vod/.*$', page: 'Player - VOD' },
    { rule: '.*/play/catchup/.*$', page: 'Player - Catchup' },
    { rule: '.*/play/live/.*$', page: 'Player - Live' },
    { rule: '.*/play/trailer/.*$', page: 'Player - Trailer' },
    { rule: '.*/play/recording/.*$', page: 'Player - Recording' },

    { rule: '.*/(filmid|movie)/[^/]+$', page: 'Movie - Detail' },
    { rule: '.*/(seriaalid-telekanalitelt|program-series)/[^/]+$', page: 'TV Series - Detail' },
    { rule: '.*/(seriaalid|vod-series)/[^/]+$', page: 'VOD Series - Detail' },
    { rule: '.*/(saated|program)/[^/]+$', page: 'Program - Detail' },
    { rule: '.*/(salvestused|recording)/[^/]+$', page: 'Recording - Detail' },

    { rule: '.*/collection/.*$', page: 'Collection page' },
    { rule: '.*/editorial/.*$', page: 'Editorial page' },
    { rule: '.*/settings/.*$', page: 'Settings' },
    { rule: '.*/search$', page: 'Search' },
    { rule: '^/(live-tv|kava|телепрограмма)$', page: 'EPG' },

    { rule: '^/huub$', page: 'Huub' },
    { rule: '^/(laenutus|rentals|прокат)$', page: 'Rentals' },
    { rule: '^/(lastele|kids|детям)$', page: 'Kids' },
    { rule: '^/(my-elisa|lemmikud|моя-elisa)$', page: 'My Elisa' },
    { rule: '^/$', page: 'Home' },
];

export const resolvePageName = (pathname: string): string | null => {
    const match = NPAW_PAGE_RULES.reduce<{ regex: RegExp; page: string } | null>((found, { rule, page }) => {
        if (found !== null) {
            return found;
        }
        try {
            const regex = new RegExp(rule);
            return pathname.match(regex) !== null ? { regex, page } : null;
        } catch {
            return null;
        }
    }, null);

    return match !== null ? pathname.replace(match.regex, match.page) : null;
};

export default NPAW_PAGE_RULES;
